import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import {
  faPlus,
  faTimes,
  faCheck,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { NzContextMenuService } from "ng-zorro-antd/dropdown";
import { NzMessageService } from "ng-zorro-antd/message";
import { forkJoin } from "rxjs";
import { XlTemplateLibraryService } from "./xl-template-library.service";
// import _ from "lodash"
import { environment } from "src/environments/environment";
import { NzTableFilterList, NzTableSortOrder } from "ng-zorro-antd/table";
import { VAIconRegistryService, close } from "@va/core-library/icons";
import { ActivatedRoute } from "@angular/router";
import { saveAs } from "file-saver";
import { FormGroup } from "@angular/forms";

interface Firm {
  id: number;
  label: string;
}
interface ColumnItem {
  name: string;
  sortFn?: boolean;
  listOfFilter?: NzTableFilterList;
  filterFn?: boolean;
  filterMultiple?: boolean;
  sortDirections?: NzTableSortOrder[];
  textAlign?: string;
  minWidth?: string;
  showSort?: boolean;
  showFilter?: boolean;
}
@Component({
  selector: "app-xl-template-library",
  templateUrl: "./xl-template-library.component.html",
  styleUrls: ["./xl-template-library.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class XlTemplateLibraryComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  faPlus = faPlus;
  faTimes = faTimes;
  faCheck = faCheck;
  faFileExcel = faFileExcel;
  clientFacing: boolean;
  fromExcelAddin: boolean;
  templateFiles: Array<any> = [];
  searchedTemplateFiles: Array<any> = [];
  filteredTemplatesFiles: Array<any> = [];
  //firms: Array<Firm> = [];
  isVisible = false;
  isEditFirmVisible = false;
  currentDisplayName = "";
  currenTemplateType = "";
  currentDisplayDescription = "";
  currentFirmSelection: Array<any> = [];
  deleteSelectedFirms = new Set<string>();
  indeterminate = false;
  checked = false;
  selectedFirm: Firm = {
    id: null,
    label: "",
  };
  currentSelectedDoc = {
    fileName: "",
    displayFileName: "",
    lastModified: new Date(),
    firmsWithAccess: [],
    fileId: "",
    isActive: 0,
  };
  loading = false;
  editId: string | null = null;
  uploadUrl = `${environment.apiUrl}/addin/add_lab_template/`;
  @ViewChild("UploadFileInput", { static: false }) uploadFileInput: ElementRef;
  fileInputLabel = "";
  currentFile: File;
  selectedFileName: string;
  showDragPage: boolean;
  showFilter: boolean;
  //sorting
  currentSortOrder = null;
  currentSortBy = null;
  //filter
  currentFilteredTemplates = [];
  //search
  searchTemplateInput = "";
  constructor(
    private nzContextMenuService: NzContextMenuService,
    private message: NzMessageService,
    private xlTemplateService: XlTemplateLibraryService,
    private iconRegistry: VAIconRegistryService,
    private route: ActivatedRoute,
  ) {
    this.iconRegistry.registerIcons([close]);
  }

  templateTypeFilters = [
    { text: "Single Company", value: "Single Company", selected: false },
    { text: "Multiple Company", value: "Multiple Company", selected: false },
    { text: "Informational", value: "Informational", selected: false },
  ];
  listOfColumns: ColumnItem[];

  searchTimeout = null;

  ngOnInit() {
    this.templateFiles = [];
    this.searchedTemplateFiles = [];
    this.clientFacing = this.route.snapshot.data["clientFacing"];
    this.fromExcelAddin = this.route.snapshot.data["fromExcelAddin"];
    this.addTableColumns();
    this.setDataTemp();
  }

  addTableColumns() {
    if (this.fromExcelAddin) {
      this.listOfColumns = [
        {
          name: "Template Name",
          sortFn: true,
          showSort: true,
          textAlign: "left",
        },
        {
          name: "Last Modified",
          textAlign: "left",
          sortFn: true,
          showSort: true,
        },
      ];
    } else {
      this.listOfColumns = [
        {
          name: "Template Name",
          sortFn: true,
          showSort: true,
          textAlign: "left",
        },
        {
          name: "Description",
          textAlign: "left",
          minWidth: "40%",
        },
        {
          name: "Type",
          textAlign: "left",
        },
        {
          name: "Last Modified",
          textAlign: "left",
          sortFn: true,
          showSort: true,
          minWidth: "10%",
        },
        {
          name: "",
          textAlign: "left",
        },
      ];
    }
  }

  ngAfterViewInit(): void {
    if (!this.clientFacing) this.addEventListener();
  }

  getTemplateTooltip(description: string){
    return description.length > 250 ? description.slice(0, 240) + '...': description;
  }

  searchTemplate(value) {
    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      this.searchTemplateInput = value;
      this.getSearchTemplateData();
    }, 500);
  }

  getSearchTemplateData() {
    this.searchedTemplateFiles = this.templateFiles.filter(
      (obj) =>
        obj.displayFileName &&
        obj.displayFileName
          .toLowerCase()
          .includes(this.searchTemplateInput.toLowerCase()),
    );
    this.filteredTemplatesFiles = [this.searchedTemplateFiles];
    this.getSortedData(this.currentSortOrder, this.currentSortBy);
    this.submitFilter();
  }

  addEventListener() {
    const div = document.getElementById("template-library");

    if (!div) {
      return;
    }

    div.addEventListener("dragover", (e) => {
      e.preventDefault();
    });

    div.addEventListener("drop", (e) => {
      e.preventDefault();
      this.showDragPage = false;
      this.showModal();
      this.onFileSelect(e, true);
    });

    div.addEventListener("dragenter", (e) => {
      e.preventDefault();
      this.showDragPage = true;
    });

    div.addEventListener("dragleave", (e) => {
      e.preventDefault();
      this.showDragPage = false;
    });
  }

  onFileSelect(event, fromDrag = false) {
    const af = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    let target = null;
    if (fromDrag) target = event.dataTransfer;
    else target = event.target;
    if (target.files.length > 0) {
      const file = target.files[0];

      if (!af.includes(file.type)) {
        this.message.warning(
          "This file is not in the Excel format. Please upload a valid Excel file (e.g., .xls or .xlsx).",
        );
      } else if (file.size / 1000 > 10000) {
        this.message.warning(
          "File size exceeds the maximum limit. Please upload a file that is 10 MB or smaller.",
        );
      } else {
        this.fileInputLabel = file.name;
        this.currentFile = file;
      }
    }
  }

  getSortedData(sortOrder, sortBy) {
    if (sortBy === null) return;

    this.currentSortBy = sortBy;
    this.currentSortOrder = sortOrder;

    const templates = [...this.filteredTemplatesFiles];
    if (sortBy === "Template Name") {
      if (sortOrder === "ascend") {
        templates.sort((a, b) =>
          a.displayFileName.localeCompare(b.displayFileName),
        );
      } else if (sortOrder === "descend") {
        templates.sort((a, b) =>
          b.displayFileName.localeCompare(a.displayFileName),
        );
      }
    } else if (sortBy === "Last Modified") {
      if (sortOrder === "ascend") {
        templates.sort((a, b) => a.lastModified - b.lastModified);
      } else if (sortOrder === "descend") {
        templates.sort((a, b) => b.lastModified - a.lastModified);
      }
    }
    this.filteredTemplatesFiles = templates;
  }

  submitFilter() {
    this.showFilter = false;
    this.currentFilteredTemplates = this.templateTypeFilters
      .filter((t) => t.selected)
      .map((t) => t.value);
    if (this.currentFilteredTemplates.length === 0) {
      this.filteredTemplatesFiles = this.searchedTemplateFiles;
      return;
    }

    this.filteredTemplatesFiles = this.searchedTemplateFiles.filter(
      (obj) =>
        obj.templateType &&
        this.currentFilteredTemplates.includes(obj.templateType),
    );
  }

  clearFilter() {
    this.showFilter = false;
    this.templateTypeFilters.map((types) => (types.selected = false));
    this.submitFilter();
  }

  onFormSubmit() {
    if (!this.currentFile || this.currentDisplayName === "") {
      this.message.warning("Please fill in all the required fields.");
      return false;
    }

    const formData = new FormData();
    formData.append("current_file", this.currentFile);
    formData.append("current_display_name", this.currentDisplayName);
    formData.append(
      "current_template_type",
      this.currenTemplateType ? this.currenTemplateType : "",
    );
    formData.append(
      "current_template_description",
      this.currentDisplayDescription,
    );
    // add post call to append entry to database
    return this.xlTemplateService.addTemplate(formData).subscribe(
      (response: any) => {
        // Reset the file input
        if (response.status === "success") {
          //const allFirms = this.firms.map((val) => val.id);
          const newFile = {
            fileName: this.currentFile.name,
            displayFileName: this.currentDisplayName,
            lastModified: new Date(),
            //firmsWithAccess: allFirms,
            fileId: response.file_id,
          };
          this.uploadFileInput.nativeElement.value = "";
          this.fileInputLabel = "";
          this.currentDisplayName = "";
          this.currenTemplateType = "";
          this.currentDisplayDescription = "";
          this.currentFile = null;
          this.isVisible = false;
          this.message.success(
            `File ${newFile.fileName} successfully uploaded !`,
          );
          this.setDataTemp();
        }
      },
      (err) => {
        this.message.error("Error :", err.message);
        this.uploadFileInput.nativeElement.value = "";
        this.fileInputLabel = "";
        this.currentDisplayName = "";
        this.currenTemplateType = "";
        this.currentDisplayDescription = "";
        this.isVisible = false;
        this.currentFile = null;
      },
    );
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.onFormSubmit();
  }
  handleCancel() {
    this.isVisible = false;
    this.currentDisplayName = "";
  }

  closeMenu(): void {
    this.nzContextMenuService.close();
  }

  showEditFirmModal(obj) {
    this.clearSelection();
    //this.isEditFirmVisible = true;
    this.currentSelectedDoc = obj;
    this.editId = obj.fileId;
    this.selectedFileName = this.currentSelectedDoc.displayFileName;
    // this.currentFirmSelection = this.firms.filter((val) =>
    //   obj.firmsWithAccess.includes(val.id),
    // );
  }
  handleFirmCancel() {
    this.isEditFirmVisible = false;
    this.clearSelection();
  }
  handleFirmOk() {
    this.isEditFirmVisible = false;
    //set to selected file
    this.currentSelectedDoc.firmsWithAccess = this.currentFirmSelection.map(
      (val) => val.id,
    );
    this.updateTemplate("editFirm").subscribe(() => {
      this.message.info(
        `File firm access changed to ${this.currentSelectedDoc.displayFileName} `,
      );
      this.currentSelectedDoc.lastModified = new Date();
      this.clearSelection();
    });
  }
  onFirmChange() {
    //check if present
    const isPresent = this.currentFirmSelection.filter(
      (val) => val.id === this.selectedFirm.id,
    );
    if (!isPresent.length) this.currentFirmSelection.push(this.selectedFirm);
  }
  onAllChecked(checked) {
    this.currentFirmSelection.forEach((item) => {
      if (checked) {
        this.deleteSelectedFirms.add(item.id);
      } else {
        this.deleteSelectedFirms.delete(item.id);
      }
    });
    this.refreshCheckedStatus();
  }
  onItemChecked(id: string, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  updateCheckedSet(id: string, checked: boolean): void {
    if (checked) {
      this.deleteSelectedFirms.add(id);
    } else {
      this.deleteSelectedFirms.delete(id);
    }
  }

  refreshCheckedStatus(): void {
    this.checked = this.currentFirmSelection.every((item) =>
      this.deleteSelectedFirms.has(item.id),
    );
    if (this.currentFirmSelection.length === 0) {
      this.checked = false;
    }
    this.indeterminate =
      this.currentFirmSelection.some((item) =>
        this.deleteSelectedFirms.has(item.id),
      ) && !this.checked;
  }

  clearSelection() {
    this.deleteSelectedFirms = new Set<string>();
    this.checked = false;
    this.indeterminate = false;
    this.selectedFirm = null;
  }
  removeFirms() {
    this.currentFirmSelection = this.currentFirmSelection.filter(
      (item) => !this.deleteSelectedFirms.has(item.id),
    );
    this.clearSelection();
  }

  addAllFirms() {
    //this.currentFirmSelection = this.firms.map((val) => val);
  }
  startEdit(id: string): void {
    this.editId = id;
  }

  stopEdit(file, save: boolean): void {
    this.editId = null;
    if (!save) {
      return;
    }
    this.currentSelectedDoc = file;
    this.currentSelectedDoc.displayFileName = this.selectedFileName;
    this.updateTemplate("editFileName").subscribe(() => {
      // call rename api with latest name
      this.message.info(`File name changed to ${file.displayFileName} `);
      this.currentSelectedDoc.lastModified = new Date();
    });
  }

  deleteFile(file) {
    //call api to delete file
    this.currentSelectedDoc = file;
    this.updateTemplate("delete").subscribe(() => {
      //show msg on success
      this.message.success(`File ${file.fileName} deleted from templates`);
      const rowIndex = this.templateFiles.findIndex(
        (val) => val.fileId === file.fileId,
      );
      this.templateFiles.splice(rowIndex, 1);
    });
  }
  setDataTemp() {
    this.loading = true;
    let p1 = this.xlTemplateService.getAllTemplates();
    if (this.clientFacing) p1 = this.xlTemplateService.getUserTemplates();

    //const p2 = this.xlTemplateService.getAllFirms();

    forkJoin([p1]).subscribe((response) => {
      this.templateFiles = response[0]["templates"];
      //this.firms = response[1]["firms"];
      // set all firms selected if firm selected is null
      //const allFirms = this.firms.map((val) => val.id);
      this.templateFiles.forEach((val) => {
        // if (val.firmsWithAccess.length === 0) {
        //   val.firmsWithAccess = allFirms;
        // }
        val.lastModified = new Date(val.lastModified);
      });
      this.loading = false;
      this.templateFiles.sort((a, b) => b.lastModified - a.lastModified);
      this.getSearchTemplateData();
    });
  }

  updateTemplate(action) {
    return this.xlTemplateService.updateTemplate(
      this.currentSelectedDoc,
      action,
    );
  }

  updateTemplateVisibility(file, isPublish) {
    this.currentSelectedDoc = file;
    this.updateTemplate(isPublish).subscribe((res: any) => {
      if (res.status === "error") {
        this.message.error(`Filed to change Template visibility`);
        return;
      }
      this.message.success(`Template is successfully ${isPublish}ed`);
      this.currentSelectedDoc.lastModified = new Date();
      this.currentSelectedDoc.isActive = isPublish === "publish" ? 1 : 0;
      this.clearSelection();
    });
  }

  downloadTemplate = (file) => {
    if (this.fromExcelAddin) {
      window.parent.postMessage(file);
      return;
    }

    this.xlTemplateService
      .downloadTemplate(file.templateId)
      .subscribe((resp: any) => {
        if (resp.status !== 200) {
          return;
        }
        const fileName =
          resp.headers.get("filename") ||
          (resp.headers.get("content-disposition") &&
            resp.headers
              .get("content-disposition")
              .split(";")[1]
              .split("filename")[1]
              .split("=")[1]
              .replace(/"/g, "")
              .trim()) ||
          undefined;
        saveAs(resp.body, `${file.displayFileName}_${fileName}`);
      });
  };

  sortTemplateName = (a, b) =>
    a.displayFileName.localeCompare(b.displayFileName);
}
